import React from 'react';

import AkPagination from '@atlaskit/pagination';

const StyledPagination = ({
  currentPage,
  pages,
  handlePageChange,
}: {
  currentPage: number;
  pages: (string | number)[];
  handlePageChange: (_event: any, newPage: any) => void;
}) => {
  const Page = React.forwardRef<HTMLButtonElement, any>(({ page: buttonPage, ...rest }, ref) => {
    if (currentPage === buttonPage - 1) {
      return (
        <button
          type="button"
          disabled
          ref={ref}
          style={{
            background: '#253858',
            color: '#f4f5f7',
            borderRadius: '3px',
            height: '2.28571em',
            padding: '0px 10px',
          }}
        >
          {buttonPage}
        </button>
      );
    }

    return (
      <button type="button" ref={ref} {...rest}>
        {buttonPage}
      </button>
    );
  });

  Page.displayName = 'PaginationPage';

  return (
    <AkPagination
      defaultSelectedIndex={currentPage}
      selectedIndex={currentPage}
      pages={pages}
      onChange={handlePageChange}
      components={{ Page }}
    />
  );
};

export default StyledPagination;
